module.exports = __webpack_public_path__ + "img/logo_white.da708e2b.png";